//定义全局过滤器  https://blog.csdn.net/qq_35285627/article/details/80805705


//金额过滤器  保留两位小数点 语法：　<any>{{表达式 | 过滤器}}</any>
exports.formatMoney = (value) => {
    if (value == null || value === '') {
        return 0.00
    } else {
        return value.toFixed(2)
    }
},
    exports.formatPercentage = (value) => {
        if (value == 0) {
            return 0
        }
        var str = Number(value * 100).toFixed();
        str += "%";
        return str;
    }


//订单类型过滤转化
exports.formatOrderType = (value) => {
    switch (value) {
        case 1:
            return '即时专送';
            break;
        case 2:
            return '预约专车';
            break;
        case 3:
            return '接送机';
            break;
        case 4:
            return '城际拼车';
            break;
        case 5:
            return '城际专车';
            break;
        case 6:
            return '接机专车';
            break;
        case 7:
            return '接机拼车';
            break;
        case 8:
            return '送机专车';
            break;
        case 9:
            return '送机拼车';
            break;
        case 10:
            return '商务用车';
            break;
        case 11:
            return '包车订单';
            break;
        case 13:
            return '代驾';
            break;
        case 14:
            return '穿梭巴士';
            break;
        case 15:
            return '租车';
            break;
        case 16:
            return '特惠拼车';
            break;
        case 17:
            return '线路包车';
            break;
        case 18:
            return '顺风车';
            break;
        case 19:
            return '会议用车';
            break;
        case 20:
            return '摇一摇用车';
            break;
        case 21:
            return '多日包车';
            break;
        case 22:
            return '定制巴士';
            break;
        case 23:
            return '手动城际';
            break;
        default:
            return '其他类型';
            break;
    }
},



    //订单状态过滤转化
    exports.formatOrderStatus = (value) => {
        switch (value) {
            case 1:
                return '待接单';
                break;
            case 2:
                return '已接单';
                break;
            case 3:
                return '司机到达上车点';
                break;
            case 4:
                return '乘客已上车（进行中）';
                break;
            case 5:
                return '到达目的地（待支付）';
                break;
            case 6:
                return '已完成';
                break;
            case 7:
                return '乘客已取消';
                break;
            case 8:
                return '司机取消';
                break;
            case 9:
                return '系统取消';
                break;
            case 10:
                return '无司机应答';
                break;
            case 11:
                return '订单改派';
                break;
            case 12:
                value = '订单等待支付';
                break;
            case 13:
                return '订单已支付';
                break;
            default:
                return '其他状态';
                break;
        }
    },

    //订单来源过滤转化
    exports.formatOrderSource = (value) => {
        switch (value) {
            case 1:
                return '易至出行';
                break;
            case 2:
                return '百度地图';
                break;
            case 3:
                return '携程旅行';
                break;
            case 4:
                return '江西航空';
                break;
            case 5:
                return '首汽约车';
                break;
            case 6:
                return '同程';
                break;
            case 11:
                return '一车一码';
                break;
            case 12:
                return '司机快速下单';
                break;
            case 13:
                return '小二下单';
                break;
            case 14:
                return '营销码下单';
                break;
            case 15:
                return '美团对接';
                break;
            case 18:
                return '扫码穿梭巴士';
                break;
            case 19:
                return '资溪下单';
                break;
            case 20:
                return '路路行';
                break;
            case 21:
                return '贵阳公交';
                break;
            case 22:
                return '南广出行';
                break;
            default:
                return '其他来源';
                break;
        }
    },


    //订单来源客户端  订单来源客户端 1：乘客端  2 司机端  3 公众号  4 车载 5 小程序
    exports.formatClientType = (value) => {
        switch (value) {
            case 1:
                return '乘客端';
                break;
            case 2:
                return '司机端';
                break;
            case 3:
                return '公众号';
                break;
            case 4:
                return "车载";
                break;
            case 5:
                return "小程序";
                break;
            case 6:
                return "小二APP";
                break;
            case 7:
                return "资溪APP";
                break;
            default:
                return '---';
                break;
        }
    }

//发票状态 0-未申请开票，1-已完成开票，2-已寄出纸质发票，3-已申请开票
exports.formatInvoiceStatus = (value) => {
    let result = null;
    if (value == null || value === '') {
        return result;
    } else {
        switch (value) {
            case 0:
                result = '未申请开票'
                break;
            case 1:
                result = '已完成开票'
                break;
            case 2:
                result = '已寄出'
                break;
            case 3:
                result = '已申请开票'
                break;
            default:
                result = null
                break;
        }
        return result;
    }
}




// WEBPACK FOOTER //
// ./src/filters/index.js